import { render } from "./BatchUpdatePromotionType.vue?vue&type=template&id=5c984ab6&ts=true"
import script from "./BatchUpdatePromotionType.vue?vue&type=script&lang=ts"
export * from "./BatchUpdatePromotionType.vue?vue&type=script&lang=ts"

import "./BatchUpdatePromotionType.vue?vue&type=style&index=0&id=5c984ab6&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__